import {TweenLite} from 'gsap';
import {mapGetters} from 'vuex';
const analyticsEvent = require('../../../../viscomjs/analytics/analyticsEvent');

export default {
    name: 'blank',
    props: {
        data: Object,
        next: String,
        nextLabel: String
    },
    computed: {
        ...mapGetters('quiz', ['getAnswer']),
        answerId() {
            return typeof this.getAnswer !== 'undefined' ? this.getAnswer(this.data.id) : '';
        },
        duration() {
            return this.durations[this.answerId] || 0.1;
        },
        durations() {
            const output = {};
            let i;
            let obj;
            for (i = 0; i < this.data.options.length; i++) {
                obj = this.data.options[i];
                output[obj.id] = obj.duration;
            }
            return output;
        }
    },
    mounted() {
        this.startCountdown();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.startCountdown();
        });
    },
    beforeRouteUpdate(to, from, next) {
        this.startCountdown();
        next();
    },
    beforeRouteLeave(to, from, next) {
        this.stopCountdown();
        next();
    },
    methods: {
        startCountdown() {
            this.stopCountdown();
            TweenLite.delayedCall(this.duration, this.gotoNext, [], this);
        },
        stopCountdown() {
            TweenLite.killDelayedCallsTo(this.gotoNext);
        },
        gotoNext() {
            analyticsEvent('Navigation', 'animation complete', this.nextLabel);
            this.$router.push(this.next);
        }
    },
    template: require('../../../../../../components/templates/blank.pug')
};
